import React, { useEffect } from 'react';
import '../styles/LeMuseeEnBref.css';
import Affiche from '../assets/sescollections/periode2/Affiche.JPG';
import VideoMusee from '../assets/videosmusee/frejusetlemusee.mp4'
import dernierecartouche from '../assets/dernierecartouche.jpg'
import crypte from '../assets/lemuseeenbref/crypte.jpg'

const LeMuseeEnBref = () => {
  useEffect(() => {
    const stats = document.querySelectorAll('.stat-number');

    function animateStats() {
      stats.forEach(stat => {
        const target = parseInt(stat.getAttribute('data-target'));
        const duration = 2000;
        const steps = 50;
        const increment = target / steps;
        let current = 0;

        const timer = setInterval(() => {
          current += increment;
          const formattedNumber = Math.round(current).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          stat.textContent = formattedNumber;

          if (current >= target) {
            stat.textContent = target.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            clearInterval(timer);
          }
        }, duration / steps);
      });
    }

    const fadeElements = document.querySelectorAll('.fade-in');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = 1;
          if (entry.target.classList.contains('stats')) {
            animateStats();
          }
        }
      });
    }, {
      threshold: 0.1
    });

    fadeElements.forEach(element => {
      observer.observe(element);
    });
  }, []);

  return (
    <main>
      <section className="hero fade-in">
        <h1>Musée des Troupes de Marine</h1>
        <p>400 ans d'histoire et d'engagement au service de la France</p>
      </section>

      <div className="cards-container">
        <div className="card fade-in">
          <img src={dernierecartouche} alt="Vue du musée" className="img-feature" />
          <div className="card-body">
            <h3>Son Histoire</h3>
            <p>Depuis son ouverture en octobre 1981, le musée des Troupes de Marine est un conservatoire de riches collections, à la fois lieu de mémoire et de commémoration.</p>
          </div>
        </div>

        <div className="card fade-in">
          <img src={Affiche} alt="Collections du musée" className="img-feature" />
          <div className="card-body">
            <h3>Ses Collections</h3>
            <p>Le musée expose environ 4 500 objets sur une collection totale de 20 000 objets conservés dans les réserves.</p>
          </div>
        </div>

        <div className="card fade-in">
          <img src={crypte} style={{ objectPosition: '50% 70%' }} alt="Crypte commémorative" className="img-feature" />
          <div className="card-body">
            <h3>Lieu de Mémoire</h3>
            <p>Notre crypte rend hommage aux 400 000 soldats des Troupes de marine et des troupes coloniales morts pour la France.</p>
          </div>
        </div>
      </div>

      <div className="contact-button-container">
        <a href="/pages/FormulaireMusee" className="contact-button">Contacter le musée</a>
      </div>

      <section className="p-5 text-center fade-in">
        <h3 style={{ color: 'var(--tdm-blue)' }}> Le Musée en Bref</h3>
        <p> Conservatoire de riches collections, le musée des Troupes de marine est à la fois un lieu de
          mémoire et de commémoration ; un musée d'histoire, de sciences et de techniques, d'arts et de
          traditions militaires ; et un pôle d'activités culturelles (expositions, conférences), de partage et
          d'aventures humaines. Au gré de ses 1 100 m² de surface d'exposition, le musée retrace
          l'Histoire des Troupes de marine. Il présente leurs différentes spécialités, la spécificité de leurs
          théâtres d'engagement et leurs grandes figures militaires. Le musée accueille plus de 17 000
          visiteurs par an, et expose environ 4 500 objets.
        </p>
        <p> Vitrine tournée vers le monde civil, le musée entretient des liens privilégiés avec l'Education
          Nationale par le biais de projets pédagogiques pluridisciplinaires, d'actions d'éducation à la
          citoyenneté et d'accompagnement de visites des lieux de mémoire par les jeunes publics.
        </p>
        <p> C'est aussi un lieu de méditation, de commémoration et de souvenir, avec sa crypte rendant
          hommage aux quelques 400 000 soldats des Troupes de marine et des troupes coloniales qui
          sont « morts pour la France » depuis quatre siècles. La présence de l'urne contenant les restes
          des soldats de Bazeilles (fait d'arme héroïque dans ce village des Ardennes en 1870) rappelle
          chaque soldat des Troupes de marine d'aujourd'hui au devoir de mémoire et à la nécessité
          d'entretenir la fraternité d'armes.
        </p>

        <div className="contact-button-container">
          <a href="/pages/FormulaireMusee" className="contact-button">Contacter le musée</a>
        </div>

        <h3 style={{ color: 'var(--tdm-blue)' }}> Extension & Modernisation</h3>
        <p> Riche de 25 000 objets, le musée est devenu « Musée de France » en 2006. C'est pour mieux
          présenter ces trésors et les conserver suivant les normes en vigueur, que l'Ecole Militaire
          Spécialisée pour l'Outre-mer et l'Etranger (EMSOME), autorité de tutelle du musée, en
          partenariat avec la Fédération Nationale des Anciens d'Outre-Mer et des Anciens Combattants
          des Troupes de Marine (FNAOM-ACTDM) et l'Association des Amis du Musée des Troupes de
          Marine (AAMTDM), soutenue par de nombreux donateurs, des mécènes et les collectivités
          territoriales, ont initié une démarche visant à agrandir et moderniser le musée.
        </p>
        <p> La surface de 1 100 m² existante a été doublée. Le musée dispose désormais d'un nouveau hall
          d'accueil-boutique et d'une salle d'exposition temporaire de 400 m².
        </p>
        <p> Le Musée, facile d'accès, est situé dans une des pinèdes qui bordent la route entre Fréjus et
          Bagnols-en-Forêt ; il est à 5 minutes en voiture de la sortie de l'autoroute A8 « Le Capitou » vers
          Fréjus et Saint-Raphaël. Il possède de grands espaces de parking. L'entrée est gratuite.
        </p>

        <div className="contact-button-container">
          <a href="/pages/FormulaireMusee" className="contact-button">Contacter le musée</a>
        </div>
      </section>

      <section className="video-container fade-in">
        <figure>
          <video className="video-border" controls>
            <source src={VideoMusee} type="video/mp4" />
            Votre navigateur ne supporte pas la lecture de vidéos.
          </video>
          <figcaption className="video-caption">Le Musée des Troupes de Marine et la ville de Fréjus</figcaption>
        </figure>
      </section>

      <section className="stats fade-in">
        <h2>Le Musée en Chiffres</h2>
        <div className="stats-grid">
          <div className="stat-item">
            <div className="stat-number" data-target="17000">0</div>
            <p>Visiteurs 2024</p>
          </div>
          <div className="stat-item">
            <div className="stat-number" data-target="4500">0</div>
            <p>Objets exposés</p>
          </div>
          <div className="stat-item">
            <div className="stat-number" data-target="1100">0</div>
            <p>m² d'exposition</p>
          </div>
        </div>
      </section>

      <section className="timeline fade-in">
        <h2>Nos Conservateurs</h2>
        <div className="conservator">
          <h4>2021-aujourd'hui</h4>
          <p>Lieutenant-colonel Bertrand PHILIP DE LABORIE</p>
        </div>
        <div className="conservator">
          <h4>2013-2021</h4>
          <p>Lieutenant-colonel Philippe ROUDIER</p>
        </div>
        <div className="conservator">
          <h4>2009-2013</h4>
          <p>Capitaine Eric WARNANT</p>
        </div>
        <div className="conservator">
          <h4>1998-2009</h4>
          <p>Lieutenant-colonel Antoine CHAMPEAUX</p>
        </div>
        <div className="conservator">
          <h4>1980-1998</h4>
          <p>Colonel Jean-Marie MASSIP</p>
        </div>
      </section>
    </main>
  );
};

export default LeMuseeEnBref;
